import { render, staticRenderFns } from "./exploration-and-production.vue?vue&type=template&id=47908580&"
import script from "./exploration-and-production.vue?vue&type=script&lang=js&"
export * from "./exploration-and-production.vue?vue&type=script&lang=js&"
import style0 from "./exploration-and-production.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports